import { apiPatch } from '@/api/api.ts'

export interface IPatchDeviceSettingRequest {
    safeZoneRadiusM?: number
    isAppPush?: boolean
    contact?: string
    address?: string
    latitude?: number
    longitude?: number
    dataIntervalMinute?: number
}

export interface IPatchDeviceSettingData {
    safeZoneRadiusM: number
    isAppPush: boolean
    contact: string
    address: string
    latitude: number
    longitude: number
    dataIntervalMinute: number
}

export interface IPatchDeviceSettingResponse {
    code: number
    message: string
    data?: IPatchDeviceSettingData
}

export const apiPatchDeviceSetting = async (params: IPatchDeviceSettingRequest): Promise<IPatchDeviceSettingResponse> => {
    const response = await apiPatch<IPatchDeviceSettingData>('/app/auth/setting', params)
    return {
        code: Number(response.code) || 200,
        message: String(response.message) || 'success',
        data: response.data
    }
}